module.exports = __webpack_public_path__ + "img/区域切除2.9a3a3268.svg";